// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import VueResource from "vue-resource";
import locale from "element-ui/lib/locale/lang/en";
import "element-ui/lib/theme-default/index.css"; // 默认主题
// import VueAMap from "vue-amap";

Vue.config.productionTip = false;
Vue.use(ElementUI, { locale });
Vue.use(VueResource);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  template: "<App/>",
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js